const HEADER_FORM = 'header-form';
const CSS_SELECTOR_INVALID_CHARS_REGEX = /[{};<!]/g;

export { HEADER_FORM, CSS_SELECTOR_INVALID_CHARS_REGEX };
